import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamZHCN() {
  return (
    <div className={styles["declaration"]}>
      <h1>关于渠道零售人员培训考试的合规声明</h1>

      <p>
        为持续提升一线第三方促销员的服务质量，小米国际部培训团队（以下简称“我司”）为外包服务商选派的一线第三方促销员（以下简称“学员”）提供培训课程及配套的知识巩固考试，旨在优化课程内容、巩固学习成果，不构成任何形式的劳动关系或实际管理行为。现就培训考试事项声明如下：
      </p>

      <ol>
        <li>
          <strong>培训考试性质说明</strong><br/>
          所有培训课程及考试均基于知识共享目的开展，旨在帮助学员系统性掌握产品信息、服务规范等。考试结果仅反映学员对当次培训内容的掌握情况，不作为绩效评估依据，我司无权且不会干预外包服务商对学员的绩效考核、薪酬分配或其他劳动关系事项。
        </li>
        <li>
          <strong>法律关系澄清</strong><br/>
          学员与所属外包服务商之间的劳动关系不受本培训考试项目影响。我司与学员之间不存在劳动关系，也不因知识共享性质的培训考试与学员产生任何事实雇佣关系。
        </li>
        <li>
          <strong>考试结果用途</strong><br/>
          考试结果仅限于以下用途：
          <ul>
            <li>作为我司内部课程优化改进的参考依据；</li>
            <li>基于外包服务商的自主判断与意愿，可提供给外包服务商作为学员专业水平的证明，作为能力参考；</li>
            <li>考试结果不会公开，亦不会向第三方披露。</li>
          </ul>
        </li>
      </ol>

      <p>
        本声明自发布之日起生效，学员参与培训考试项目即视为已阅读并同意本声明内容。我司保留对本声明的最终解释权及合理修订权。
      </p>

      <div className={styles["footer"]}>
        小米国际部培训团队<br/>
        日期：{getLocalizedTime('zh-CN')}
      </div>
    </div>
  );
}